import { Button } from "../../components/Button";
import { formatIrkutskDateTime, formatIrkutskLocalDateTime } from "../../lib/time";

const RAFFLE_TZ_LABEL = "Иркутск (UTC+8)";

export function AdminActionsSection({
  actionDraft,
  setActionDraft,
  editingActionId,
  onActionSubmit,
  startEditAction,
  cancelEditAction,
  loading,
  actions,
  toggleAction,
  removeAction,
  actionEntriesById,
  loadingActionEntriesId,
  loadActionEntries,
}) {
  const kindLabel = actionDraft.kind === "raffle" ? "розыгрыш" : "акцию";
  const submitLabel = editingActionId
    ? `Сохранить ${kindLabel === "розыгрыш" ? "розыгрыш" : "акцию"}`
    : `Добавить ${kindLabel}`;
  const itemKindLabel = (kind) => (kind === "raffle" ? "Розыгрыш" : "Акция");
  const isRaffle = actionDraft.kind === "raffle";
  const seatsParsed = Number(actionDraft.raffle_seats);
  const seats = Number.isFinite(seatsParsed) && seatsParsed > 0 ? seatsParsed : 1;

  const onSeatsChange = (value) => {
    const raw = String(value ?? "");
    if (raw.trim() === "") {
      // Разрешаем очистить поле во время редактирования, без автоподстановки "1".
      setActionDraft((prev) => ({ ...prev, raffle_seats: "" }));
      return;
    }
    const parsed = Number(raw);
    if (!Number.isFinite(parsed)) return;
    const nextSeats = Math.max(1, Math.floor(parsed));
    setActionDraft((prev) => {
      const nextPrizes = Array.from(
        { length: nextSeats },
        (_, i) =>
          prev.raffle_prizes?.[i] || { title: "", is_bonus_points: false, bonus_amount: "" },
      );
      return { ...prev, raffle_seats: String(nextSeats), raffle_prizes: nextPrizes };
    });
  };

  const onPrizeChange = (index, patch) => {
    setActionDraft((prev) => {
      const next = Array.from(
        { length: seats },
        (_, i) =>
          prev.raffle_prizes?.[i] || { title: "", is_bonus_points: false, bonus_amount: "" },
      );
      next[index] = { ...next[index], ...patch };
      return { ...prev, raffle_prizes: next };
    });
  };

  return (
    <>
      <form className="adminForm" onSubmit={onActionSubmit}>
        <h3>{editingActionId ? "Редактировать запись" : "Добавить запись"}</h3>
        <label className="field">
          Тип
          <select
            value={actionDraft.kind}
            onChange={(e) => {
              const kind = e.target.value;
              setActionDraft((prev) => ({
                ...prev,
                kind,
                raffle_seats: prev.raffle_seats || "3",
                raffle_prizes:
                  prev.raffle_prizes && prev.raffle_prizes.length > 0
                    ? prev.raffle_prizes
                    : [
                        { title: "", is_bonus_points: false, bonus_amount: "" },
                        { title: "", is_bonus_points: false, bonus_amount: "" },
                        { title: "", is_bonus_points: false, bonus_amount: "" },
                      ],
              }));
            }}
          >
            <option value="action">Акция</option>
            <option value="raffle">Розыгрыш</option>
          </select>
        </label>
        <label className="field">
          Заголовок
          <input
            type="text"
            placeholder="Например, Кальян 1+1"
            value={actionDraft.title}
            onChange={(e) => setActionDraft((prev) => ({ ...prev, title: e.target.value }))}
          />
        </label>
        <label className="field">
          Описание акции
          <textarea
            rows="3"
            placeholder="Короткое описание для гостей"
            value={actionDraft.description}
            onChange={(e) =>
              setActionDraft((prev) => ({ ...prev, description: e.target.value }))
            }
          />
        </label>
        {isRaffle ? (
          <>
            <label className="field">
              Количество мест
              <input
                type="number"
                min={1}
                value={actionDraft.raffle_seats}
                onChange={(e) => onSeatsChange(e.target.value)}
              />
            </label>
            <label className="field">
              Дата и время проведения
              <input
                type="datetime-local"
                value={actionDraft.raffle_draw_at}
                onChange={(e) =>
                  setActionDraft((prev) => ({ ...prev, raffle_draw_at: e.target.value }))
                }
              />
              <small className="muted">Часовой пояс: {RAFFLE_TZ_LABEL}</small>
            </label>
            <div className="field">
              Призы по местам
              <div className="adminItemActions" style={{ marginTop: 8 }}>
                {Array.from({ length: seats }, (_, i) => (
                  <div key={i} className="field" style={{ marginBottom: 6 }}>
                    <input
                      type="text"
                      placeholder={`Место ${i + 1}: название приза`}
                      value={actionDraft.raffle_prizes?.[i]?.title || ""}
                      onChange={(e) => onPrizeChange(i, { title: e.target.value })}
                      disabled={Boolean(actionDraft.raffle_prizes?.[i]?.is_bonus_points)}
                    />
                    <label className="field field--inline">
                      <input
                        type="checkbox"
                        checked={Boolean(actionDraft.raffle_prizes?.[i]?.is_bonus_points)}
                        onChange={(e) =>
                          onPrizeChange(i, {
                            is_bonus_points: e.target.checked,
                            bonus_amount: e.target.checked
                              ? actionDraft.raffle_prizes?.[i]?.bonus_amount || ""
                              : "",
                          })
                        }
                      />
                      Приз баллами
                    </label>
                    {Boolean(actionDraft.raffle_prizes?.[i]?.is_bonus_points) ? (
                      <input
                        type="number"
                        min={1}
                        placeholder="Количество баллов"
                        value={actionDraft.raffle_prizes?.[i]?.bonus_amount || ""}
                        onChange={(e) => onPrizeChange(i, { bonus_amount: e.target.value })}
                      />
                    ) : null}
                  </div>
                ))}
              </div>
            </div>
          </>
        ) : null}
        <label className="field field--inline">
          <input
            type="checkbox"
            checked={actionDraft.is_active}
            onChange={(e) =>
              setActionDraft((prev) => ({ ...prev, is_active: e.target.checked }))
            }
          />
          Активировать сразу
        </label>
        <label className="field field--inline">
          <input
            type="checkbox"
            checked={Boolean(actionDraft.notify_on_activate)}
            onChange={(e) =>
              setActionDraft((prev) => ({ ...prev, notify_on_activate: e.target.checked }))
            }
          />
          Оповестить всех при активации
        </label>
        <Button type="submit" variant="accent">
          {submitLabel}
        </Button>
        {editingActionId ? (
          <Button type="button" onClick={cancelEditAction}>
            Отмена редактирования
          </Button>
        ) : null}
      </form>

      <section className="adminGroup">
        <h3>Акции</h3>
        {loading ? <p className="muted">Загрузка...</p> : null}
        {!loading && actions.length === 0 ? <p className="muted">Пока нет записей.</p> : null}
        {!loading
          ? actions.map((item) => (
              <article key={item.id} className="adminItem adminItem--stack">
                <div className="adminItem">
                  <div>
                  <h4>{item.title}</h4>
                  <p className="muted">Тип: {itemKindLabel(item.kind)}</p>
                  {item.kind === "raffle" ? (
                    <p className="muted">
                      Мест: {item.raffle_seats || 0}
                      {item.raffle_draw_at
                        ? ` · Розыгрыш: ${formatIrkutskLocalDateTime(item.raffle_draw_at)} (${RAFFLE_TZ_LABEL})`
                        : ""}
                    </p>
                  ) : null}
                  {item.kind === "raffle" ? (
                    <p className="muted">Участники: {Number(item.raffle_participants_count || 0)}</p>
                  ) : null}
                  {item.kind === "raffle" && Array.isArray(item.raffle_prizes) && item.raffle_prizes.length > 0 ? (
                    <p className="muted">
                      Призы:{" "}
                      {item.raffle_prizes
                        .map((p, i) =>
                          p?.is_bonus_points
                            ? `${i + 1} место — ${p.bonus_amount || 0} баллов`
                            : `${i + 1} место — ${p?.title || "Приз"}`
                        )
                        .join(" | ")}
                    </p>
                  ) : null}
                  {item.kind === "raffle" && Array.isArray(item.raffle_winners) && item.raffle_winners.length > 0 ? (
                    <p className="muted">
                      Победители:{" "}
                      {item.raffle_winners
                        .map((w) => {
                          const winnerLabel = w.full_name
                            ? `${w.full_name} (id ${w.telegram_id})`
                            : `id ${w.telegram_id}`;
                          return `${w.place} место: ${w.prize} — ${winnerLabel}`;
                        })
                        .join(" ; ")}
                    </p>
                  ) : null}
                  <p>{item.description}</p>
                  <p className="muted">
                    Статус: {item.is_active ? "активна" : "черновик"}
                  </p>
                  </div>
                  <div className="adminItemActions">
                    {item.kind === "raffle" ? (
                      <Button type="button" onClick={() => loadActionEntries(item.id)}>
                        {loadingActionEntriesId === item.id ? "Загрузка..." : "Участники"}
                      </Button>
                    ) : null}
                    <Button type="button" onClick={() => toggleAction(item)}>
                      {item.is_active ? "Деактивировать" : "Активировать"}
                    </Button>
                    <Button type="button" onClick={() => startEditAction(item)}>
                      Редактировать
                    </Button>
                    <Button type="button" onClick={() => removeAction(item)}>
                      Удалить
                    </Button>
                  </div>
                </div>
                {item.kind === "raffle" && Array.isArray(actionEntriesById?.[item.id]) ? (
                  <div className="adminGroup">
                    {actionEntriesById[item.id].length === 0 ? (
                      <p className="muted">Пока нет зарегистрированных участников.</p>
                    ) : (
                      <div className="adminItem adminItem--stack">
                        {actionEntriesById[item.id].map((u) => {
                          const name = [u.last_name, u.first_name].filter(Boolean).join(" ").trim();
                          const label = name || (u.username ? `@${u.username}` : `id ${u.telegram_id}`);
                          return (
                            <p key={`${item.id}:${u.telegram_id}:${u.joined_at}`} className="muted">
                              {label} ({formatIrkutskDateTime(u.joined_at)})
                            </p>
                          );
                        })}
                      </div>
                    )}
                  </div>
                ) : null}
              </article>
            ))
          : null}
      </section>
    </>
  );
}

